import React from 'react'

import {Spinner, Stack} from '../../UI/index.js'
import {loadingOverlayStyle} from '../styles.js'

/** Dims the map with a spinner while its data loads, below the map's controls so they stay usable */
export default function MapLoadingOverlay({loading}: {loading?: boolean}) {
    if (!loading) {
        return null
    }

    return (
        <Stack aria-busy style={loadingOverlayStyle}>
            <Spinner />
        </Stack>
    )
}
